module.exports = __webpack_public_path__ + "media/images/doorsticker3-2f4d3c6e9f492741eeecf6dd21f573bf.jpg";